import React, {useContext} from 'react';

import {colors} from '../../../../theme';
import {RouterTabsContext} from '../router-tab-list';

import {RouterTabComponent} from './styled';

// Example:
//
// <RouterTabList baseUrl={url}>
//     <RouterTab url="">Пользователи</RouterTab>
//     <RouterTab url="roles">Роли</RouterTab>
//     <RouterTab url="roles2">Роли 2</RouterTab>
// </RouterTabList>

// <RouterSwitch rootPath={path}>
//     <Route path={`${path}`} exact>
//         <Title size={3}>Users</Title>
//     </Route>
//     <Route path={`${path}/roles`} exact>
//         <Title size={3}>Roles</Title>
//     </Route>
//     <Route path={`${path}/roles2`} exact>
//         <Title size={3}>Roles 2</Title>
//     </Route>
// </RouterSwitch>

interface Props {
    className?: string;
    forceActive?: boolean;
    url: string;
}

export const RouterTab = ({
    url,
    className,
    children,
    forceActive,
}: React.PropsWithChildren<Props>) => {
    const baseUrl = useContext(RouterTabsContext);
    const fullUrl = url ? `${baseUrl}/${url}` : baseUrl;

    return (
        <RouterTabComponent
            className={className}
            exact
            isActive={(match: any) => {
                if (forceActive) return true;
                return Boolean(match);
            }}
            to={fullUrl}
            activeStyle={{
                borderBottom: `2px solid ${colors.brandPrimary}`,
            }}
        >
            {children}
        </RouterTabComponent>
    );
};
